/** The workspace layout: rail, reveal handles, navigation and send notices. */
export default {
  frameOpenFailedTitle: "Couldn't open frame",
  frameOpenFailedBody: "The frame may have been deleted or moved.",
  closeWorkspace: "Close Workspace",
  showFocusControls: "Show focus controls",
  showSidebar: "Show sidebar",
  chooseProjectForMemory: "Choose a project to open Memory.",
  memoryOpenFailed: "Couldn’t open Memory. Try again.",
  newProject: "New project",
  manageProjects: "Manage projects…",
  desktopNeededTitle: "Denker needs a desktop right now",
  desktopNeededBody:
    "Please open Denker on a Mac or PC. The canvas workspace needs a precise pointer and more screen space than your current device can provide.",
  mobileComingSoon: "Mobile & iPad apps coming soon",
  visionModelTitle: "Choose a model that supports images",
  visionModelBody:
    "Your images are still attached. Switch models or remove them before sending.",
  sharedFiles: {
    one: "Shared a file",
    other: "Shared {count} files",
  },
  sentMessage: "Sent a message",
  pastedImage: "Pasted Image",
  untitled: "Untitled",
  note: "Note",
  agent: "Agent",
  unknownError: "Unknown error",
  taskBoardFailed: "Failed to create task board",
  heartbeatOn: "Heartbeat ON",
  heartbeatOff: "Heartbeat OFF",
  agentsUpdated: {
    one: "{count} agent updated",
    other: "{count} agents updated",
  },
  heartbeatFailed: "Failed to toggle heartbeat",
  maxUsage: "Usage: /max <1–10>",
  voiceUsage: "Usage: /voice, /voice on or /voice off",
  maxSet: "Max parallel agents set to {value}",
  maxFailed: "Failed to update max parallel agents",
  currently: "Currently {value}",
  on: "ON",
  off: "OFF",
  dragCanvas: "Drag canvas",
  dragCanvasShortcut: "Drag canvas · {shortcut}",
} as const;
